import * as React from "react";
import { inject } from "mobx-react";
import { Viewport, ViewSmall, ViewLarge } from "bernie-view";
import { LocalizedText, formatText } from "bernie-l10n";

import {
  DestinationNeighborhoodsProps,
  DestinationNeighborhoodsViewProps,
  NeighborhoodCardsProps
} from "./typings";
import { Neighborhood } from "typings/microserviceModels/te-neighborhood-flex-module";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import { JumplinkItem } from "components/flexComponents/Jumplinks/Jumplinks";
import { NeighborhoodCard } from "./NeighborhoodCard";
import ViewWhereToStayGuideButton from "./components/ViewWhereToStayGuideButton";

@inject("dx")
export class DestinationNeighborhoods extends React.Component<DestinationNeighborhoodsProps> {
  private readonly jumplinkRef: React.RefObject<HTMLDivElement>;
  private jumplink: JumplinkItem;

  constructor(props: DestinationNeighborhoodsProps) {
    super(props);
    this.jumplinkRef = React.createRef();
  }

  /* istanbul ignore next line */
  public componentDidMount() {
    const componentHasData: boolean =
      this.props.flexComponent.model &&
      !this.props.flexComponent.model.empty &&
      this.props.flexComponent.model.content &&
      this.props.flexComponent.model.content.items &&
      this.props.flexComponent.model.content.items.length > 0;

    this.jumplink = {
      identifier: 1,
      name: "Where To Stay",
      icon: "lob_hotels",
      reference: this.jumplinkRef,
      localisedName: formatText("jumplinks.whereToStay")
    };

    const checkForExistingReference = (reference: JumplinkItem) => {
      return reference["name"] === this.jumplink.name;
    };

    const addUpdatedReference = (reference: JumplinkItem) => {
      if (this.props.dx && reference["name"] === this.jumplink.name) {
        const index = this.props.dx.jumplinksArray.indexOf(reference);
        this.props.dx.jumplinksArray.splice(index, 1);
        this.props.dx.jumplinksArray.push(this.jumplink);
      }
    };

    if (this.props.dx && componentHasData) {
      if (
        this.props.dx.jumplinksArray.some((reference: JumplinkItem) =>
          checkForExistingReference(reference)
        )
      ) {
        this.props.dx.jumplinksArray.map((reference: JumplinkItem) =>
          addUpdatedReference(reference)
        );
      } else {
        this.props.dx.jumplinksArray.push(this.jumplink);
      }
    }
  }

  /* istanbul ignore next line */
  public componentWillUnmount() {
    if (this.props.dx) {
      if (this.props.dx.jumplinksArray.includes(this.jumplink)) {
        this.props.dx.jumplinksArray.splice(this.props.dx.jumplinksArray.indexOf(this.jumplink), 1);
      }
    }
  }

  public render() {
    return (
      <DestinationNeighborhoodsView
        flexComponent={this.props.flexComponent}
        context={this.props.context}
        jumplinkRef={this.jumplinkRef}
      />
    );
  }
}

const DestinationNeighborhoodsView = (props: DestinationNeighborhoodsViewProps) => {
  const { flexComponent, context, jumplinkRef } = props;
  const { model } = flexComponent;
  const { content } = model;

  if (!(content && content.items && content.items.length)) {
    return null;
  }

  const neighborhoods: Neighborhood[] = content.items.slice(0, 6);
  const { whereToStayUrl } = content;

  const neighborhoodsKeyHelper: ItemKeyHelper = new ItemKeyHelper("popular-neighborhood");

  return (
    <div
      className="DestinationNeighborhoods all-y-padding-six uitk-cell all-cell-1-1"
      id={flexComponent.id}
      data-fm={flexComponent.fmId}
      data-fm-title-id={flexComponent.fmTitleId}
      ref={jumplinkRef}
    >
      <h3 className="uitk-type-heading-600 all-b-margin-four">
        {context.searchContext.location.type === "neighborhood" ? (
          <LocalizedText
            message="destinationNeighborhood.neighborhood.title"
            data={[context.searchContext.location.parent.name]}
          />
        ) : (
          <LocalizedText
            message="destinationNeighborhood.title"
            data={[context.searchContext.location.name]}
          />
        )}
      </h3>

      <Viewport>
        <ViewSmall>
          <div className="destinationNeighborhoodsContainer">
            <NeighborhoodCards
              neighborhoods={neighborhoods}
              neighborhoodsKeyHelper={neighborhoodsKeyHelper}
              context={context}
              isDesktop={false}
            />
          </div>
        </ViewSmall>
        <ViewLarge>
          <div className="destinationNeighborhoodsContainer uitk-grid all-cell-1-3 all-x-gutter-three">
            <NeighborhoodCards
              neighborhoods={neighborhoods}
              neighborhoodsKeyHelper={neighborhoodsKeyHelper}
              context={context}
              isDesktop={true}
            />
          </div>
        </ViewLarge>
      </Viewport>

      {whereToStayUrl && <ViewWhereToStayGuideButton href={whereToStayUrl} />}
    </div>
  );
};

const NeighborhoodCards = (props: NeighborhoodCardsProps) => {
  return (
    props.neighborhoods &&
    props.neighborhoods.length &&
    props.neighborhoods.map((neighborhood: Neighborhood, neighborhoodIndex: number) => (
      <NeighborhoodCard
        key={props.neighborhoodsKeyHelper.next()}
        className="all-b-margin-three"
        neighborhood={neighborhood}
        position={neighborhoodIndex + 1}
        context={props.context}
        isDesktop={props.isDesktop}
        showFavorite={true}
        isClickeable={true}
      />
    ))
  );
};

export default DestinationNeighborhoods;
